<template>
  <div>
    <v-btn
      v-if="type === 'url'" 
      depressed
      color="primary"
      @click="visit(value)"
      class="mt-6"
      v-text="__(title)"
    />
    <template v-else>
      <div v-text="__(title)" class="text-subtitle-1 pt-4 black--text" />
      <template v-if="Array.isArray(value)">
        <div v-for="line in value" v-text="line" class="text-body-2 pl-1 pb-1" />
      </template>
      <div v-else v-text="value" class="text-body-2 pl-1" />
    </template>
  </div>
</template>

<script>
  import I18n from '@/Mixins/I18n'

  export default {
    mixins: [
      I18n,
    ],

    props: {
      type: {
        required: false,
        type: String,
        default: 'text',
      },
      title: {
        required: true,
        type: String,
      },
      value: {
        required: true,
        type: [Array, String],
      },
    },

    methods: {
      async visit (url) {
        AndroidDevice.visit(url)
      },
    },
  }
</script>
